/** Dairesel stratejik-skor göstergesi (Yeni Etkinlik formu + Yönetici Özeti ortak kullanır). */

const GAUGE_R = 58
const GAUGE_C = 2 * Math.PI * GAUGE_R

export type GaugeTone = 'low' | 'mid' | 'high'

/** Öncelik bandı tonu → renk (gauge yayı + skor sayısı rengi; tek kaynak). */
export const GAUGE_COLOR: Record<GaugeTone, string> = {
  low: 'var(--faint)',
  mid: 'var(--prog)',
  high: 'var(--done)',
}

interface ScoreGaugeProps {
  /** 0–100 skor; `null` ise skorsuz (boş/uygulanamaz — ilerleme yayı çizilmez, sayı yerine —). */
  score: number | null
  /** Yay rengi bandı (öncelik düzeyi). */
  tone: GaugeTone
}

export default function ScoreGauge({ score, tone }: Readonly<ScoreGaugeProps>) {
  const has = score != null
  const pct = has ? Math.min(score, 100) / 100 : 0
  return (
    <div className="ev-gauge">
      <svg viewBox="0 0 132 132" aria-hidden>
        <circle cx="66" cy="66" r={GAUGE_R} fill="none" stroke="var(--slate-100)" strokeWidth="12" />
        {has && (
          <circle
            cx="66"
            cy="66"
            r={GAUGE_R}
            fill="none"
            stroke={GAUGE_COLOR[tone]}
            strokeWidth="12"
            strokeLinecap="round"
            strokeDasharray={GAUGE_C}
            strokeDashoffset={GAUGE_C * (1 - pct)}
          />
        )}
      </svg>
      <div className="ev-gauge-num">
        <b>{has ? score : '—'}</b>
        <span>/ 100</span>
      </div>
    </div>
  )
}
